import { WorkerFunction } from './worker-function-detail.types';

/**
 * `before` / `after` are the claim-edit payload serialized to a string. Returns `undefined` — never
 * an empty object — when a side is absent or does not parse, so the caller can say "not recorded"
 * instead of showing every field as added or removed.
 */
export function getWorkerFunctionPayload(workerFunction: WorkerFunction, phase: 'before' | 'after'): unknown {
    let value: unknown = phase === 'before' ? workerFunction.before : workerFunction.after;

    // Tolerate a double-encoded payload (a JSON string containing JSON), as coding notes can be.
    for (let attempt = 0; attempt < 2 && typeof value === 'string'; attempt++) {
        try {
            value = JSON.parse(value);
        } catch {
            return undefined;
        }
    }

    return value !== null && typeof value === 'object' ? value : undefined;
}
